import React from "react";

const About = () => {
  return (
    <div>
      <h1 className="text-center">Book Finder App</h1>
      <p className="lead">
        Book Finder is a simple web app built with React and the Google Books
        API that lets you search for books and displays information based on the
        results of the search.
      </p>
    </div>
  );
};

export default About;
